import { request } from "../callApi";

export const getRatesData = (data: any[]) => {
  if (!Array.isArray(data)) return [];

  const ratesData = [...data]
    .sort((a, b) => (a.SortOrder ?? 0) - (b.SortOrder ?? 0))
    .map((rate: any) => ({
      sourceCurrency: rate.SourceISO ?? rate.sourceCurrency,
      targetCurrency: rate.TargetISO ?? rate.targetCurrency,
      buy: rate.BuyRate ? rate.BuyRate.toFixed(4) : rate.buyRate?.toFixed(4),
      sell: rate.SellRate
        ? rate.SellRate.toFixed(4)
        : rate.sellRate?.toFixed(4),
      buyIBAN: rate.BuyIBAN ?? rate.buyIBAN,
      sellIBAN: rate.SellIBAN ?? rate.sellIBAN,
      nbgRate: rate.NBGRate ? rate.NBGRate.toFixed(4) : null,
      descrip: rate.Descrip ?? null,
      code: rate.SourceISO
        ? `${rate.SourceISO}/${rate.TargetISO}`
        : `${rate.sourceCurrency}/${rate.targetCurrency}`,
      amount: rate.Multiplier || 1,
      sortOrder: rate.SortOrder ?? 0, // სურვილის შემთხვევაში
    }));

  return ratesData;
};

const normalizeRate = (rate: number, multiplier?: number) =>
  rate / (multiplier || 1);

export const currencySellRateData = (data: any, tab: number) => {
  const sellRates: any = { GEL_GEL: 1 };

  // logic to get sell rate
  data?.forEach((rate: any) => {
    const multiplier = rate.Multiplier || 1;

    if (tab !== 2) {
      // ნაღდი / უნაღდო
      // sellRates[rate.SourceISO] = normalizeRate(Number(rate.SellRate), multiplier);
      const key = `${rate.SourceISO}_${rate.TargetISO}`;
      sellRates[key] = normalizeRate(Number(rate.SellRate), multiplier);
    } else {
      const key = `${rate.sourceCurrency}_${rate.targetCurrency}`;
      sellRates[key] = normalizeRate(Number(rate.sellRate), multiplier || 1);
    }
  });

  return sellRates;
};

export const currencyBuyRateData = (data: any, tab: number) => {
  const buyRates: Record<string, number> = { GEL: 1 };
  // logic to get sell rate
  data?.forEach((rate: any) => {
    const multiplier = rate.Multiplier || 1;

    if (tab !== 2) {
      // ნაღდი / უნაღდო
      const key = `${rate.SourceISO}_${rate.TargetISO}`;
      buyRates[key] = normalizeRate(Number(rate.BuyRate), multiplier);
    } else {
      // ონლაინ
      const key = `${rate.sourceCurrency}_${rate.targetCurrency}`;
      buyRates[key] = normalizeRate(Number(rate.buyRate), multiplier);
    }
  });
  return buyRates;
};

export const parseFloatSafe = (value: string) => {
  if (value === "") return "";

  if (/^[0-9]*[.]?[0-9]*$/.test(value)) {
    return value;
  }
  const num = parseFloat(value);

  return isNaN(num) ? "" : num;
};

export const handleSubmit = async (formData: any, endPoint: string) => {
  const { REACT_APP_KEEPZ_URL } = process.env;

  const res = await request(
    `${REACT_APP_KEEPZ_URL}${endPoint}`,
    "POST",
    {
      personalId: formData.personalId,
      phone: formData.mobileNumber,
      otp: formData.otp,
    },
    {
      "Content-Type": "application/json",
      Accept: "application/json",
      "channel-name": process.env.REACT_APP_CHANNEL_NAME,
      authorization: `Bearer ${process.env.REACT_APP_AUTHORITION_TOKEN}`,
    },
  );

  return res;
};
